import { FC } from 'react';
import { mergeClasses } from 'shared/utils/mergeClasses';

export interface LoadingSpinnerProps {
  size?: number;
  className?: string;
}

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ size = 36, className = '' }) => {
  return (
    <div
      className={mergeClasses(
        'spinner animate-spin rounded-full border-2 border-primary-500 border-b-transparent border-l-transparent [animation-duration:.5s]',
        className,
      )}
      style={{
        width: size,
        height: size,
      }}
    />
  );
};
